<template>
  <div id="ylAboutHistory">
    <ylAboutHistoryMobile v-if="isMobileScreen" :list="list" />
    <ylAboutHistoryPC v-else :list="list" />
  </div>
</template>
<script>
export default {
  name: "ylAboutHistory",
  components: {
    ylAboutHistoryMobile: () => import("./components/mobile.vue"),
    ylAboutHistoryPC: () => import("./components/pc.vue"),
  },
  data() {
    return {
      list: [],
    };
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() {
    this.history();
  },
  methods: {
    async history() {
      let res = await this.$api.history();
      this.list = res;
    },
  },
};
</script>